import Component from "../../classes/Component";
import {$events} from "../../helpers/events";

const videoPlayerSelector = '.js-video-player'

export default function () {
    const handlePlayOrStopVideo = (e) => {
        if (e.target.paused) {
            e.target.play()
        } else {
            e.target.pause()
        }
    }

    return new Component({
        name: 'video',
        requiredTargets: [videoPlayerSelector],
        onInit() {
            $events.delegate.on('click', videoPlayerSelector, handlePlayOrStopVideo)

        },
        onDestroy() {
            console.log('video')
        },
    })

}